import { config } from "core/config/app";
import CartPage from "./pages/CartPage";

const router = [
  {
    name: "CARTS",
    auth: true,
    exact: true,
    path: `${config?.basename}/carts`,
    element: <CartPage />,
    title: "Carts",
  },
];
export default router;
